"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var condition_fail_reason_model_1 = require("../../models/condition-fail-reason.model");
var condition_fail_event_model_1 = require("../../models/condition-fail-event.model");
var BaseCondition = /** @class */ (function () {
    function BaseCondition(name, notificationService) {
        this.conditionName = name;
        this.notificationService = notificationService;
    }
    BaseCondition.prototype.onConditionFail = function (error, errorMessage) {
        console.log(errorMessage);
        if (this.notificationService) {
            var conditionFailEvent = new condition_fail_event_model_1.ConditionFailEvent(this.conditionName, condition_fail_reason_model_1.ConditionFailReason[error], errorMessage);
            this.notificationService.sendConditionFailEvent(conditionFailEvent);
        }
    };
    return BaseCondition;
}());
exports.BaseCondition = BaseCondition;
